export default "__VITE_ASSET__426ef2dc__"